/**
 * The "Special Offer" jar-quantity + Subscribe/One-time widget on the product
 * page is rendered by the Section Store app inside an open Shadow DOM that
 * populates asynchronously (GraphQL fetch), so it can't be edited via theme
 * liquid/CSS. This watches that widget and, whenever "Subscribe and Save" is
 * selected, forces the quantity to the app's lowest-quantity option (normally
 * "One Jar") and disables the other jar-count options until the shopper
 * switches back to a one-time purchase.
 */
(function () {
  if (window.__bundleSubscriptionQtyLock) return;
  window.__bundleSubscriptionQtyLock = true;

  var TAG = 'section-store--bundle-block';
  var LOCK_CLASS = 'bundle-option--qty-locked';

  function pickBaseShortId(rawConfig) {
    try {
      var config = JSON.parse(rawConfig);
      var options = config && config[0] && config[0].options;
      if (!options || !options.length) return null;

      var base = options[0];
      for (var i = 1; i < options.length; i++) {
        var oQty = options[i].volume_discount && options[i].volume_discount.minimum_quantity;
        var bQty = base.volume_discount && base.volume_discount.minimum_quantity;
        if (typeof oQty === 'number' && (typeof bQty !== 'number' || oQty < bQty)) {
          base = options[i];
        }
      }
      return base.short_id || null;
    } catch (err) {
      return null;
    }
  }

  function labelFor(root, input) {
    if (!input.id) return null;
    var labels = root.querySelectorAll('label.bundle-option-radio-label');
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].htmlFor === input.id) return labels[i];
    }
    return null;
  }

  function injectStyle(root) {
    if (root.querySelector('style[data-qty-lock-style]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-qty-lock-style', '');
    style.textContent = '.' + LOCK_CLASS + '{display:none !important;}';
    root.appendChild(style);
  }

  function setLocked(root, baseShortId, locked) {
    var inputs = root.querySelectorAll('input[name="bundle_option_id"]');
    var baseInput = null;
    inputs.forEach(function (input) {
      if (input.value === baseShortId) baseInput = input;
    });
    if (!baseInput) return;

    if (locked && !baseInput.checked) {
      var baseLabel = labelFor(root, baseInput);
      if (baseLabel) baseLabel.click();
    }

    inputs.forEach(function (input) {
      if (input.value === baseShortId) return;
      input.disabled = locked;
      var label = labelFor(root, input);
      if (label) label.classList.toggle(LOCK_CLASS, locked);
    });
  }

  function wireBundleBlock(el) {
    if (el.__qtyLockWired) return;
    var root = el.shadowRoot;
    if (!root) return;

    var hasOptions = root.querySelector('input[name="bundle_option_id"]');
    var hasSub = root.querySelector('input[name="subscription_on"]');
    if (!hasOptions || !hasSub) return;

    var baseShortId = pickBaseShortId(el.getAttribute('data-block-bundles'));
    if (!baseShortId) return;

    el.__qtyLockWired = true;
    injectStyle(root);

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.name !== 'subscription_on') return;
      setLocked(root, baseShortId, t.value === '1' && t.checked);
    });

    var checkedSub = root.querySelector('input[name="subscription_on"]:checked');
    if (checkedSub && checkedSub.value === '1') setLocked(root, baseShortId, true);
  }

  function watchForShadowContent(el) {
    wireBundleBlock(el);
    if (el.__qtyLockWired) return;

    if (!el.shadowRoot) {
      requestAnimationFrame(function () { watchForShadowContent(el); });
      return;
    }

    var mo = new MutationObserver(function () {
      wireBundleBlock(el);
      if (el.__qtyLockWired) mo.disconnect();
    });
    mo.observe(el.shadowRoot, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  document.querySelectorAll(TAG).forEach(watchForShadowContent);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(TAG)) watchForShadowContent(node);
        if (node.querySelectorAll) node.querySelectorAll(TAG).forEach(watchForShadowContent);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
